import React, { PropsWithChildren, useState } from 'react';

import { Icon } from '@iconify/react';
import chevronDown from '@iconify/icons-mdi/chevron-down';
import chevronUp from '@iconify/icons-mdi/chevron-up';

import type { ChannelListMessengerProps } from 'stream-chat-react';

export type SupportChannelListProps = ChannelListMessengerProps & {
  type: string;
};

const ChannelList = (props: PropsWithChildren<SupportChannelListProps>) => {
  const { children, error = false, loading, type } = props;
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  if (error) {
    return type === 'cleanerSupport' ? (
      <div className="team-channel-list">
        <p className="team-channel-list__message">
          Connection error, please wait a moment and try again.
        </p>
      </div>
    ) : null;
  }

  if (loading) {
    return (
      <div className="team-channel-list">
        <p className="team-channel-list__message loading">
          {type === 'cleanerSupport' ? 'Cleaners Support' : 'Clients Support'}{' '}
          loading....
        </p>
      </div>
    );
  }

  return (
    <div className="team-channel-list">
      <div className="team-channel-list__header">
        <button onClick={toggleCollapse} className="toggle-collapse-button">
          <Icon icon={isCollapsed ? chevronDown : chevronUp} />
        </button>
        <p className="team-channel-list__header__title">
          {type === 'cleanerSupport' ? 'Cleaners Support' : 'Clients Support'}
        </p>
      </div>
      {!isCollapsed && children}
    </div>
  );
};

export const SupportChannelList = React.memo(ChannelList);
